<template>
  <div>
    <documents-add-edit-modal
      v-if="showDocumentsModal"
      v-model="showDocumentsModal"
      :sidebarItems="sidebarItems"
      :selectedSidebarItemIndex="selectedSidebarItemIndex"
      sidebarTitle="Documents"
      :modalTitle="modalTitle"
      :modalSubtitle="modalSubtitle"
      :reloadSelectedDocument="reloadSelectedDocument"
      :scheduleEventId="scheduleEvent.id"
      :scheduleEventParticipantId="participant.id"
      @onModify="onModify"
      @setCurrentFormItem="setCurrentFormItem"
      :disableEffectiveDatePicker="true"
    />
  </div>
</template>

<script>
import moment from "moment";
import DocumentsAddEditModal from "../document_archive/DocumentsAddEditModal";
import { mapGetters } from "vuex";

export default {
  name: "GroupSessionParticipantNotesAddEditModal",
  components: { DocumentsAddEditModal },
  props: ["participant", "scheduleEvent"],
  data() {
    return {
      sidebarItems: null,
      selectedSidebarItemIndex: 0,
      showDocumentsModal: false,
      documents: [],
      reloadSelectedDocument: +new Date()
    };
  },
  async mounted() {
    const sidebarItems = [];
    for (
      let index = 0;
      index < this.participant.linkedDocuments.length;
      index++
    ) {
      const linkedDocument = this.participant.linkedDocuments[index];
      sidebarItems.push({
        formId: linkedDocument.form.id,
        documentId: linkedDocument.document ? linkedDocument.document.id : null,
        clientId: this.participant.episodeOfCare.patient.id,
        eocId: this.participant.episodeOfCare.id,
        name: linkedDocument.form.name,
        tooltip: linkedDocument.form.name,
        documentStatus: linkedDocument.document
          ? linkedDocument.document.status
          : "",
        documentRefNumber: linkedDocument.document
          ? linkedDocument.document.documentRefNumber
          : null,
        date: linkedDocument.document
          ? linkedDocument.document.createdAt
          : null,
        patient: this.formatUser(this.participant.episodeOfCare.patient),
        patientData: this.participant.episodeOfCare.patient,
        mrn: this.participant.episodeOfCare.mrnEocn,
        totalSignature: linkedDocument.document
          ? linkedDocument.document.totalSignatures
          : null,
        completedSignature: linkedDocument.document
          ? linkedDocument.document.completedSignatures
          : null,
        initialEffectiveDateTime: this.scheduleEvent.startDateTime,
        isEnabledInScheduleEventLocation:
          linkedDocument.isEnabledInScheduleEventLocation
      });
    }
    this.sidebarItems = sidebarItems.sort((a, b) =>
      a.name.localeCompare(b.name)
    );
    await this.goToTheNextAvailableForm();
    this.showDocumentsModal = true;
  },
  methods: {
    onModify(params) {
      this.$emit("onModify", params);
    },
    async setCurrentFormItem(params) {
      this.sidebarItems[this.selectedSidebarItemIndex].documentId =
        params.prevDocumentId;
      this.sidebarItems[this.selectedSidebarItemIndex].documentStatus =
        params.prevDocumentStatus;

      if (params.documentRefNumber) {
        this.sidebarItems[this.selectedSidebarItemIndex].documentRefNumber =
          params.documentRefNumber;
      }

      this.sidebarItems[this.selectedSidebarItemIndex].totalSignature =
        params.totalSignatures;
      this.sidebarItems[this.selectedSidebarItemIndex].completedSignature =
        params.completedSignatures;

      this.selectedSidebarItemIndex =
        params.sidebarItemIndex >= this.sidebarItems.length
          ? 0
          : params.sidebarItemIndex;
      this.reloadSelectedDocument = +new Date();
    },
    goToTheNextAvailableForm() {
      const index = this.sidebarItems.findIndex(item =>
        this.formIsEnabledInLocation(item)
      );

      if (index !== -1) {
        this.selectedSidebarItemIndex = index;
      }
    },
    formIsEnabledInLocation(item) {
      if (item) {
        return (
          this.formsMainAndMasterTreatmentPlanCurrentLocation.filter(
            item => item.id === item.formId
          ).length > 0 || item.isEnabledInScheduleEventLocation
        );
      }
    }
  },
  computed: {
    ...mapGetters("client", ["formsMainAndMasterTreatmentPlanCurrentLocation"]),
    modalTitle() {
      return this.formatEocObj(this.participant.episodeOfCare);
    },
    modalSubtitle() {
      const duration = moment
        .duration(
          moment(this.scheduleEvent.endDateTime).diff(
            moment(this.scheduleEvent.startDateTime)
          )
        )
        .asMinutes();

      return `Group Date & Time: ${this.formatDate(
        this.scheduleEvent.startDateTime
      )} (${Math.round(duration)}min)`;
    }
  }
};
</script>
